import { ChartEventLabels, ChartEventType } from '../constants/common'
import ChartEvent from './chart-event'

class Split extends ChartEvent {
  static type = ChartEventType.Split
  static label = ChartEventLabels[ChartEventType.Split]
}

export default Split
